import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Button } from "../../Button/Button";
import Link from "next/link";

export const BasicInfoContainer = styled("div")(({ theme }) => ({
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._600,
    alignSelf: "stretch",

    "@media (max-width: 600px)": {
        width: "100%"
    }
}));

export const ImageContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
    width: theme.space._1150,
    height: theme.space._1050
}));

export const Title = styled(Typography)(({ theme }) => ({
    color: theme.colors["neutral.50"],
    textAlign: "center",
    fontSize: theme.fontSizes["3xl"],
    fontFamily: theme.fonts.default,
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.slim
}));

export const FieldsContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._400,
    alignSelf: "stretch"
}));

export const NameInputContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "flex-start",
    gap: theme.space._400,
    alignSelf: "stretch"
}));

export const ForgottenPasswordLink = styled(Typography)(({ theme }) => ({
    color: theme.colors["neutral.50"],
    alignSelf: "start",
    fontSize: theme.fontSizes.sm,
    fontFamily: theme.fonts.default,
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.base
}));

export const CustomSubmitButton = styled(Button)(({ theme }) => ({
    display: "flex",
    padding: "1rem 1.5rem",
    justifyContent: "center",
    alignItems: "center",
    gap: "0.5rem",
    alignSelf: "stretch"
}));

export const StyledLink = styled(Link)(({ theme }) => ({
    color: theme.colors["blue.400"],
    textDecoration: "none"
}));

export const AlreadyMemberButton = styled(Typography)(({ theme }) => ({
    color: theme.colors["neutral.50"],
    textAlign: "center",
    fontSize: theme.fontSizes.md,
    fontFamily: theme.fonts.default,
    fontWeight: theme.fontWeights.semibold,
    lineHeight: theme.lineHeights.short
}));